var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt16"},[_c('folders-list-links',{attrs:{"items":_vm.countries}}),(_vm.currentPage<_vm.totalPage)?_c('pagination-panel-default',{attrs:{"if-active":_vm.loadingNextPage},on:{"load-more":_vm.loadNext}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }